/**
 * 모바일 표시용 짧은 formatter. 모두 KST 기준.
 */

const TZ = 'Asia/Seoul';

const SHORT_TIME = new Intl.DateTimeFormat('ko-KR', {
  timeZone: TZ,
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});
const SHORT_DATE = new Intl.DateTimeFormat('ko-KR', {
  timeZone: TZ,
  month: 'numeric',
  day: 'numeric',
});
const FULL_DATETIME = new Intl.DateTimeFormat('ko-KR', {
  timeZone: TZ,
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

/** 오늘이면 HH:mm, 올해면 M/d, 작년 이전이면 YYYY/M/d */
export function shortWhen(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  const now = new Date();
  const sameDay =
    d.toDateString() === now.toDateString();
  if (sameDay) return SHORT_TIME.format(d);
  const sameYear = d.getFullYear() === now.getFullYear();
  if (sameYear) return SHORT_DATE.format(d);
  return FULL_DATETIME.format(d).split(' ')[0] ?? '-';
}

export function fullWhen(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return FULL_DATETIME.format(d);
}

/** 초 단위를 사람 읽기 좋게 (예: 75 → "1분 15초", 9 → "9초") */
export function durationLabel(seconds: number | null | undefined): string {
  if (seconds == null || !Number.isFinite(seconds)) return '-';
  const s = Math.max(0, Math.round(seconds));
  if (s < 60) return `${s}초`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  return r === 0 ? `${m}분` : `${m}분 ${r}초`;
}

const CATEGORY_LABEL_KO: Record<string, string> = {
  work: '업무',
  service: '서비스',
  personal: '개인',
  etc: '기타',
};
export function categoryLabel(c: string | null | undefined): string | null {
  if (!c) return null;
  return CATEGORY_LABEL_KO[c] ?? c;
}

const STATUS_LABEL_KO: Record<string, string> = {
  captured: '대기 중', // privacy-first: 폰 캡처 직후 초기 상태 (proxy 처리 전)
  uploaded: '대기 중', // (구) 서버 업로드 모델 — 하위호환
  transcribing: '전사 중',
  summarizing: '요약 중',
  ready: '완료',
  failed: '실패',
};
export function callStatusLabel(s: string | null | undefined): string {
  if (!s) return '';
  return STATUS_LABEL_KO[s] ?? s;
}

/** 폰번호 마지막 4자리 정도만 노출 — contact_name이 있으면 그쪽이 우선 */
export function phoneOrFallback(name: string | null, phone: string | null): string {
  if (name && name.trim()) return name;
  if (phone && phone.trim()) return phone;
  return '알 수 없음';
}
